import { namespacedClassnames } from '../../common';
import * as React from 'react';
import { Tooltip } from '../tooltip/tooltip';
export var tabsKey = 'tabs';
var Tab = function (props) {
    var className = namespacedClassnames('tab', { selected: props.selected, disabled: props.disabled });
    return React.createElement("div", { className: className, "data-value": props.key, onClick: props.onSelect }, props.children);
};
export var Tabs = function (props) {
    var className = namespacedClassnames(tabsKey, props.size || '', props.className || '');
    var onChangeTab = function (tab) { return function () {
        if (!tab.disabled) {
            props.onChange(tab.key);
        }
    }; };
    var createTab = function (tab) {
        var isSelected = props.selected.includes(tab.key);
        var tabElement = tab.disabled && tab.disabledTooltip ? (React.createElement(Tooltip, { body: tab.disabledTooltip }, tab.element)) : tab.element;
        return (React.createElement(Tab, { key: tab.key, selected: isSelected, onSelect: onChangeTab(tab), disabled: tab.disabled }, tabElement));
    };
    return React.createElement("div", { className: className }, props.items.map(createTab));
};
//# sourceMappingURL=tabs.js.map